import React, { FC } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { ResponsiveBar, BarDatum, BarTooltipProps } from '@nivo/bar';

import { CustomContainer } from '../common';
import { getNivoTheme, isEmptyArray, CHART_HEIGHT, CHART_HEIGHT_MOBILE } from './utils';

const DEFAULT_COLOR_HEX = '#FE9A76';

interface TimeSeriesChartProps {
  color?: string;
  data: BarDatum[];
  enableLabel?: boolean;
  indexBy: string;
  isFetching: boolean;
  isMobile: boolean;
  keys: string[];
  title: string;
  tooltip?: any;
}

const TimeSeriesChart: FC<TimeSeriesChartProps> = ({
  color,
  data,
  enableLabel = true,
  indexBy,
  isFetching,
  isMobile,
  keys,
  title,
  tooltip,
}) => (
  <CustomContainer>
    <Header as={isMobile ? 'h3' : 'h2'} attached="top">
      {title}
    </Header>
    {
      isEmptyArray(data) ? (
        <Segment
          attached
          loading={isFetching}
        >
          <p>沒有任何資料喔...</p>
        </Segment>
      ) : (
        <Segment
          attached
          loading={isFetching}
          style={{ height: isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT }}
        >
          <ResponsiveBar
            theme={getNivoTheme(isMobile)}
            data={data}
            keys={keys}
            indexBy={indexBy}
            margin={{
              top: 20,
              right: 20,
              bottom: 80,
              left: 50,
            }}
            padding={isMobile ? 0.4 : 0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={[color || DEFAULT_COLOR_HEX]}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: isMobile ? -80 : -45,
            }}
            axisLeft={{
              format: (e) => Math.floor(e) === e && e,
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
            }}
            tooltip={tooltip}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            animate
            enableLabel={enableLabel}
          />
        </Segment>
      )
    }
  </CustomContainer>
);

export default TimeSeriesChart;